export default __webpack_public_path__ + "static/media/covid6.eebe1f4f.jpg";